import { render, staticRenderFns } from "./MedicalNoteCategoryEdit.vue?vue&type=template&id=7bb2b32a"
import script from "./MedicalNoteCategoryEdit.vue?vue&type=script&lang=js"
export * from "./MedicalNoteCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports